<div class="router-container" [@splashTransition]="prepareRoute(o)">
  <router-outlet class="router" #o="outlet"></router-outlet>
</div>
<app-cgu *ngIf="cguDisplayed"></app-cgu>
<app-iecook
  *ngIf="!cguDisplayed && !(isCookiesConsentSetByUser$ | async)"
  (manageCookies)="onManageCookies($event)"
></app-iecook>
<div class="cgu-iekooc-overlay-shadow" *ngIf="(cguDisplayed || cookieDisplayed)"></div>